import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlices";
import dashboardReducer from "./features/dashbaord/dashboardSlice";
import plansReducer from "./features/plans/plansSlice";
import subscriptionReducer from "./features/subscription/subscriptionSlice";
import companyEmployeeReducer from "./features/company/employee/employeeSlice";
import companyRequisitionReducer from "./features/company/requisition/requisitionSlice";
import companyDepartmentReducer from "./features/company/department/departmentSlice";
import companyDesignationReducer from "./features/company/userManagement/designation/designationSlice";
import companyapplyLeaveReducer from "./features/company/leaveManagement/applyLeave/applyLeaveSlice";
import companyLeaveTypeReducer from "./features/company/leaveManagement/leaveType/leaveTypeSlice";
import companyHolidayReducer from "./features/company/leaveManagement/holiday/holidaySlice";
import companyLeaveDetailsReducer from "./features/company/leaveManagement/leaveDetails/leaveDetailsSlice";
import companySalaryStructureReducer from "./features/company/payrollManagement/salaryStructure/salaryStructureSlice";
import companySalaryConfigurationReducer from "./features/company/payrollManagement/salaryConfiguration/salaryConfigurationSlice";
import processPayrollReducer from "./features/company/payrollManagement/processPayroll/processPayrollSlice";
import attendanceRecordsReducer from "./features/company/attendanceManagement/attendanceRecords/attendanceRecordsSlice";
import themeReducer from "./features/theme/themeSlice";
import rolesReducer from "./features/admin/roleManagement/role/roleSlice";
import permissionsReducer from "./features/admin/roleManagement/permission/permissionSlice";
import roleAccessReducer from "./features/admin/roleManagement/roleAccess/roleAccessSlice";
import companyProjectReducer from "./features/company/projectManagement/project/projectSlice";
import companyMilestoneReducer from "./features/company/projectManagement/milestone/milestoneSlice";
import companyTaskReducer from "./features/company/projectManagement/task/taskSlice";
import companyProjectReportReducer from "./features/company/projectManagement/report/reportSlice";
import companyRolesReducer from "./features/company/roleManagement/roleSlice";
import rolePermissionReducer from "store/features/company/roleManagement/rolePermissionSlice";
import employeeRoleReducer from "store/features/company/roleManagement/employeeRoleSlice";
import companyChatReducer from "./features/company/chat/chatSlice";
import attendancePolicyReducer from "./features/company/attendanceManagement/attendancePolicy/attendancePolicySlice";
import regularizationReducer from "store/features/company/attendanceManagement/regularization/regularizationSlice";
import leaveAdjustmentReimbursementReducer from "./features/company/leaveManagement/leaveAdjustmentReimbursement/leaveAdjustmentReimbursementSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  plans: plansReducer,
  subscription: subscriptionReducer,
  companyEmployee: companyEmployeeReducer,
  companyDepartment: companyDepartmentReducer,
  companyDesignation: companyDesignationReducer,
  companyapplyLeave: companyapplyLeaveReducer,
  companyLeaveType: companyLeaveTypeReducer,
  companyHoliday: companyHolidayReducer,
  companyLeaveDetails: companyLeaveDetailsReducer,
  companyLeaveAdjustmentReimbursement: leaveAdjustmentReimbursementReducer,
  leaveAdjustmentReimbursement: leaveAdjustmentReimbursementReducer,
  companySalaryStructure: companySalaryStructureReducer,
  companySalaryConfiguration: companySalaryConfigurationReducer,
  processPayroll: processPayrollReducer,
  attendanceRecords: attendanceRecordsReducer,
  theme: themeReducer,
  roles: rolesReducer,
  companyRoles: companyRolesReducer,
  permissions: permissionsReducer,
  roleAccess: roleAccessReducer,
  companyProject: companyProjectReducer,
  companyMilestone: companyMilestoneReducer,
  companyTask: companyTaskReducer,
  companyProjectReport: companyProjectReportReducer,
  rolePermissions: rolePermissionReducer,
  companyEmployeeRoles: employeeRoleReducer,
  companyRequisition: companyRequisitionReducer,
  companyChat: companyChatReducer,
  attendancePolicy: attendancePolicyReducer,
  regularization: regularizationReducer,
});

export default rootReducer;
